import { NumberInlineEditor } from 'components/inline_edit/NumberInlineEditor';
import { updateTimeRange } from 'custom_hooks/data_hooks/time_ranges/useTimeRange';
import { TimeRangeTableCellProps } from 'pages/Settings/TimeRanges/TimeRanges';

const errorMessage = 'Unable to save time range time.';

export function TimeRangeTimeCell({ rowData, onChange }: TimeRangeTableCellProps) {
    const onSave = async (newValue: number | undefined) => {
        if (newValue === undefined) {
            return errorMessage;
        }
        try {
            await updateTimeRange(rowData, { TimeInSeconds: newValue });
            onChange();
        } catch {
            return errorMessage;
        }
        return undefined;
    };
    return (
        <NumberInlineEditor
            ariaLabel={`${rowData.Name} time cell`}
            onConfirm={onSave}
            value={rowData.TimeInSeconds}
            validate={(value) => {
                if (value === undefined) {
                    return 'Time is required.';
                }
                if (value < 1) {
                    return 'Time must be at least 1 second.';
                }
                if (value > 31536000) {
                    return 'Time can not be greater than 31536000 seconds.';
                }
                return undefined;
            }}
        />
    );
}
